<template>
  <div>
    <page-title heading="Rekam Medis" :breadcrumb="[
      {
        label: 'Rekam Medis'
      },
      {
        label: 'Riwayat',
        active: true
      }
    ]" defaultSlotCol="7" rightSlot>
      <template v-slot:defaultSlot>
        <b-col sm="8" md="12">
          <b-row>
            <b-col sm="12" md="8">
              <h5 class="display-4 mt-1 mb-2 font-weight-bold text-left">Riwayat Rekam Medis</h5>
            </b-col>
            <b-col sm="12" md="4" class="text-right">
              <b-button variant="primary" class="text-uppercase" v-show="showBackButton()"
                @click="kembali()">kembali</b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </page-title>
    <div class="container-fluid" style="zoom: 80%;">
      <div class="card card-box mb-3">
        <div class="card-body p-4">
          <b-row style="">
            <b-col sm="12">
              <b-row>
                <b-col md="2">
                  <div class="mx-auto text-center ">
                    <img src="@/assets/img/icon-pasien.png" class="thumbnail-pasien img-fluid" alt="">
                  </div>
                </b-col>
                <b-col md="10">
                  <b-row>
                    <b-col md="6">
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Nama Pasien</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ pasien.nama || '-' }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">No. Rekam Medis</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ pasien.nomor_rekam_medis_manual ? `${pasien.nomor_rekam_medis}/${pasien.nomor_rekam_medis_manual}` : pasien.nomor_rekam_medis }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Jenis Kelamin</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{  jenisKelamin(pasien.jenis_kelamin) || '-' }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Tanggal Lahir (usia)</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ pasien.current_age || '-' }}
                        </div>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Agama</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ dataLoaded ? pasien.agama || '-' : '' }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Alamat Pasien</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ formatAlamatPasien() }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Golongan Darah</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ dataLoaded ? pasien.golongan_darah || '-' : '' }}
                        </div>
                      </div>
                      <div class="form-group row mb-header">
                        <label for="staticEmail" class="col-sm-4 col-form-label">Tanggal Konsultasi Terakhir</label>
                        <div class="col-sm-8 form-control-plaintext">
                          : {{ pasien.last_visit || '-' }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="card card-box mb-3">
        <div class="card-body p-4">
          <h5 class="text-uppercase font-weight-bold">riwayat rekam medis</h5>
          <b-row>
            <b-col md="6">
              <div class="form-group row mb-header">
                <label for="staticEmail" class="col-sm-3 col-form-label font-weight-bold"
                  style="margin-top: 10px;">Diagnosis</label>
                <div class="col-sm-7 form-control-plaintext">
                  <vue-select :options="selectDataRiwayat" :filterable="false" v-model="selected"
                    @input="searchByDiagnosis" style="font-size:13.4px;">
                    <template slot="no-options">
                      Cari berdasarkan diagnosis
                    </template>
                    <template slot="option" slot-scope="option">
                      {{ option.label }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ option.label }}
                    </template>
                  </vue-select>
                </div>
              </div>
              <div class="form-group row mb-header">
                <label for="staticEmail" class="col-sm-3 col-form-label font-weight-bold" style="margin-top: 10px;">Filter
                  Periode</label>
                <div class="col-sm-7 form-control-plaintext">
                  <b-form-select v-model="periodeSelected" :options="filterPeriode"></b-form-select>
                  <div v-show="selectedPeriodeRange" class="mt-1">
                    <DatePickerX v-model="dateRange" is-range
                      :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }" :masks="{ input: 'DD-MM-YYYY' }"
                      :max-date="maxDate" :min-date="minDate" style="width: 100%;">
                      <template v-slot="{ inputValue, inputEvents }">
                        <div class="flex justify-center items-center">
                          <template v-if="dateRange">
                            <input readonly :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                              class="form-control" />
                          </template>
                          <template v-else>
                            <input readonly placeholder="Pilih Tanggal" v-on="inputEvents.start" class="form-control" />
                          </template>
                        </div>
                      </template>
                    </DatePickerX>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <div class="mt-5">
            <b-row>
              <b-col>
                <div class="d-flex text-capitalize align-items-center">
                  <span>show</span>
                  <b-form-select :options="entriesOpt([])" class="w-25 mx-2" v-model="perPage"></b-form-select>
                  <span>entries</span>
                </div>
              </b-col>
              <b-col class="pr-0">
                <div class="d-flex justify-content-end">
                  <slot name="right-header"></slot>
                </div>
              </b-col>
              <b-col class="text-right" v-if="this.haveBpjsType">
                <b-button class="mr-4 custom-blue" variant="primary" @click="icareHandler">I-CARE JKN</b-button>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <div class="table-responsive mt-4">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Waktu Konsultasi</th>
                        <th>Diagnosis</th>
                        <th>Nama Dokter</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="pointer" v-bind:class="data.id == selectedRMId ? 'table-primary' : ''" @click="selectRM(data.id)"
                        v-for="data in dataRiwayat" :key="data.id">
                        <td scope="row">{{ data.no }}</td>
                        <td scope="row">{{ formatWaktuKonsultasi(data.waktu_konsultasi) }}</td>
                        <td scope="row">{{ getDiagnosaPrimerSekunder(data.diagnosa, data.diagnosa_result, data.kode_penyakit) }}</td>
                        <td scope="row">{{ data.nama_dokter }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination class="d-flex justify-content-center mt-4" v-model="currentPage" :total-rows="rows"
                  :per-page="perPage"></b-pagination>
              </b-col>
            </b-row>

            <div class="mt-3">
              <b-list-group horizontal class="header-list">
                <b-list-group-item class="b-list" :active="activeBlock == 'poliklinik'"
                  @click="selectBlock('poliklinik')">Poliklinik</b-list-group-item>
                <b-list-group-item class="b-list" :active="activeBlock == 'ttv'"
                  @click="selectBlock('ttv')">Tanda-Tanda Vital &
                  Anamnesis</b-list-group-item>
                <b-list-group-item class="b-list" :active="activeBlock == 'pemeriksaan_fisik'"
                  @click="selectBlock('pemeriksaan_fisik')">Pemeriksaan
                  Fisik</b-list-group-item>
                <b-list-group-item class="b-list" :active="activeBlock == 'odontogram'"
                  @click="selectBlock('odontogram')" v-if="isPoliGigi">Odontogram</b-list-group-item>
                <b-list-group-item class="b-list" :active="activeBlock == 'diagnosis'"
                  @click="selectBlock('diagnosis')">Diagnosis &
                  Tata Laksana</b-list-group-item>
                <b-list-group-item class="b-list" :active="activeBlock == 'surat_penunjang'"
                  @click="selectBlock('surat_penunjang')">Pemeriksaan & Surat
                  Penunjang</b-list-group-item>
              </b-list-group>
            </div>


          </div>
        </div>
      </div>

      <div v-if="dataRM" v-show="activeBlock == 'poliklinik'">
        <Poliklinik :dataRM="dataRM" />
      </div>
      <div v-if="dataRM" v-show="activeBlock == 'ttv'">
        <TandaTandaVital :dataRM="dataRM" :dataPasien="pasien" :poliGigi="isPoliGigi" />
      </div>
      <div v-if="dataRM" v-show="activeBlock == 'pemeriksaan_fisik'">
        <PemeriksaanFisik :dataRM="dataRM" />
      </div>
      <div v-if="dataRM && isPoliGigi" v-show="activeBlock == 'odontogram'">
        <Odontogram :dataRM="dataRM" />
      </div>
      <div v-if="dataRM" v-show="activeBlock == 'diagnosis'">
        <DiagnosisTataLaksana :dataRM="dataRM" />
      </div>
      <div v-if="dataRM" v-show="activeBlock == 'surat_penunjang'">
        <PemeriksaanSuratPenunjang :dataRM="dataRM" :dataRujukan="dataRujukan" />
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy
} from "@fortawesome/free-solid-svg-icons";
import "vue-datetime/dist/vue-datetime.css";
import startCase from "lodash/startCase";
import moment from "moment";
moment.locale('id');
import { mapGetters } from "vuex"


library.add(faArrowRight, faArrowUp, faTrashAlt, faSearch, faPencilAlt, faCopy);
export default {
  props: {
    pasien_id: [Number, String],
    rekam_medis_id: {
      required: false,
      type: Number,
      default: () => null,
    }
  },
  data() {
    return {
      haveBpjsType: false,
      dataLoaded: false,
      pasien: "",
      klinik_id: "",
      selected: null,
      dataRiwayat: [],
      selectDataRiwayat: [],
      activeBlock: 'poliklinik',
      dataRM: null,
      dataRujukan: null,
      periodeSelected: "semua",
      perPage: 10,
      dateRange: null,
      selectedRMId: null,
      rows: null,
      currentPage: 1,
      isPoliGigi: false,
    }
  },
  computed: {
    fieldList() {
      return (
        [
          {
            key: "no",
            label: "No.",
            thClass: "pt-4 pb-4 head-custom",
            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
          },
          {
            key: "waktu_konsultasi",
            label: "Waktu Konsultasi",
            thClass: "pt-4 pb-4 head-custom",
            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
          },
          {
            key: "kode_penyakit",
            label: "Diagnosis",
            thClass: "pt-4 pb-4 head-custom",
            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
          },
          {
            key: "nama_dokter",
            label: "Nama Dokter",
            thClass: "pt-4 pb-4 head-custom",
            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
          },
        ]
      )
    },
    ...mapGetters([
      "getKlinikId",
    ]),
    minDate() {
      return moment().subtract(300, 'months').toDate();
    },
    maxDate() {
      return moment().toDate()
    },
    filterPeriode() {
      return (
        ["semua", "hari ini", "minggu ini", "bulan ini", "pilih tanggal"] |> (x => x.map(item => ({
          value: item,
          text: startCase(item)
        })))
      );
    },
    selectedPeriodeRange() {
      const {
        periodeSelected
      } = this;
      return /(pilih)/gi.test(periodeSelected);
    },
  }
  ,
  components: {
    Poliklinik: () => import("./Section/Poliklinik.vue"),
    TandaTandaVital: () => import("./Section/TandaTandaVital.vue"),
    PemeriksaanFisik: () => import("./Section/PemeriksaanFisik.vue"),
    Odontogram: () => import("./Section/Odontogram.vue"),
    DiagnosisTataLaksana: () => import("./Section/DiagnosisTataLaksana.vue"),
    PemeriksaanSuratPenunjang: () => import("./Section/PemeriksaanSuratPenunjang.vue"),
    "vue-select": () => import("@/components/VueSelectClearable.vue"),
    DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
  },
  beforeRouteLeave(to, from, next) {
    if (localStorage.getItem('IDLE') != 1) {
      localStorage.removeItem('rekam_medis');
      next();
    } else {
      localStorage.removeItem('rekam_medis');
      next();
    }
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.showLeftRekamMedis();
      }
    },
    periodeSelected(val) {
      if (val !== "pilih tanggal") {
        this.showLeftRekamMedis();
      } else {
        this.dateRange = null;
      }
    },
    perPage(val) {
      this.showLeftRekamMedis()
    },
    dateRange: {
      handler: function (val) {
        if (this.periodeSelected === "pilih tanggal") {
          this.showLeftRekamMedis()
        }
      },
      deep: true
    },
  },
  methods: {
    async icareHandler(){
      try {
        const response = await axios.post(
          `${this.url_api}/bpjs/icare/fktp?klinik_id=${this.getKlinikId}`,
          {
            param: this.pasien['bpjs_noka']
          }
        );

        if(response.data.metaData.code == 200 && response.data.metaData.message == "Sukses"){
          window.open(response.data.response.url, '_blank');
        } else {
          this.$swal({
            text: response.data.metaData.message,
            type: "error",
            showCancelButton: false,
          });
        }
      } catch (error) {
        // console.error(error);
      }
    },
    formatWaktuKonsultasi(date){
      let [datePart, timePart] = date.split(' ');
      let [year, month, day] = datePart.split('-');
      let formattedDate = `${day}-${month}-${year}`;
      let formattedDateTime = `${formattedDate} ${timePart}`;
      return formattedDateTime;
    },
    getDiagnosaPrimerSekunder(diagnosa, diagnosa_result, kode_penyakit){
      let deskripsi = '';
      if(diagnosa.kode_penyakit_json){
        const kodePenyakitJson = JSON.parse(diagnosa.kode_penyakit_json);
        const kodediagnosaPrimer = diagnosa_result.kode_penyakit.filter(item => kodePenyakitJson.primary.includes(item.id));
        const kodediagnosaSekunder = diagnosa_result.kode_penyakit.filter(item => kodePenyakitJson.secondary.includes(item.id));
        
        if(kodediagnosaPrimer.length > 0){
          deskripsi = kodediagnosaPrimer[0].description;
        }
  
        if(kodediagnosaSekunder.length > 0){
          kodediagnosaSekunder.forEach(element => {
            deskripsi += `, ${element.description}`
          });
        }
        return deskripsi;
      }

      return kode_penyakit;
    },
    formatAlamatPasien(){
      if (!this.dataLoaded) return ''

      if(this.pasien.alamat_rumah && this.pasien.kota && this.pasien.provinsi){
        return `${this.pasien.alamat_rumah}, ${this.pasien.kota.nama}, ${this.pasien.provinsi.provinsi_nama}`
      }
      
      if(this.pasien.alamat_rumah && this.pasien.kota){
        return `${this.pasien.alamat_rumah}, ${this.pasien.kota.nama}`
      }
      
      if(this.pasien.alamat_rumah && this.pasien.provinsi){
        return `${this.pasien.alamat_rumah}, ${this.pasien.provinsi.provinsi_nama}`
      }

      return '-'
    },
    selectRM(id) {
      if (this.selectedRMId == id) return
      this.selectedRMId = id;
      this.showRightRekamMedis(id);
    },
    selectBlock(block) {
      this.activeBlock = block
    },
    showBackButton() {
      if (localStorage.getItem('ALLOW_BACK_MR_TAB') == 1) {
        return true;
      }
      return false;
    },
    kembali() {
      let url = localStorage.getItem('rekam_medis')
      this.$router.push({
        path: url
      });
    },
    async fetchPasien() {
      let url = localStorage.getItem('rekam_medis')
      let withParentQS = '';
      withParentQS = '&with_parent=1';

      let res = await axios.get(`${this.url_api}/pasien/${this.pasien_id}?klinik_id=${this.getKlinikId}&id=${this.pasien_id}${withParentQS}`);
      if (res.data.status == false || res.data.data_rm == false) {
        this.$swal({
          type: "error",
          title: startCase("Gagal"),
          text: startCase(`Pasien ${res.data.data.nama} belum memiliki rekam medis!`)
        }).then(res => {
          if (res.value) {
            this.$router.push({
              path: url
            });
          }
        });
      }
      this.pasien = res.data.data;
      this.dataLoaded = true
    },
    rekamMedis({
      pasien_id,
      klinik_id
    }) {
      this.$router.push(`/klinik/rekam-medis/${klinik_id}/${pasien_id}`);
    },
    fetchKodePenyakit() {
      let withParentQS = '';
      if (localStorage.getItem('with_parent') == 1) {
        withParentQS = '&with_parent=1';
      }
      var pasien_id = this.$router.currentRoute.params.pasien_id;
      axios.get(`${this.url_api}/rekam_medis/pasien/kode_penyakit/${pasien_id}?klinik_id=${this.getKlinikId}&pasien_id=${pasien_id}${withParentQS}`)
        .then(res => {
          res.data.data.forEach(item => {
            this.selectDataRiwayat.push({
              label: `${item.kode} - ${item.description}`,
              value: item.id
            })
          })
          res.data.data_bpjs.forEach(item => {
            this.selectDataRiwayat.push({
              label: `${item.kode} - ${item.description}`,
              value: item.id
            })
          })
        });
    },
    searchByDiagnosis($event) {
      this.showLeftRekamMedis()
    },
    async showLeftRekamMedis(firstLoad = false) {
      try {
        var pasien_id = this.$router.currentRoute.params.pasien_id;

        let search = '';
        if (this.selected) {
          search = `&kode_penyakit_id=${this.selected.value}`
        }
        let withParentQS = '';
        if (localStorage.getItem('with_parent') == 1) {
          withParentQS = '&with_parent=1';
        }

        search += `&page=${this.currentPage}`
        search += `&limit=${this.perPage}`
        search += '&detail_rm=1';
        search += this.dateRangeFilter(false)

        const responsePage = await axios.get(
          `${this.url_api}/rekam_medis/pasien/${pasien_id}?klinik_id=${this.getKlinikId}&pasien_id=${pasien_id}${search}${withParentQS}`);
        const { success } = responsePage.data
        if (success) {
          this.dataRiwayat = [];
          responsePage.data.data.rekam_medis.data.forEach(item => {
            if(!this.haveBpjsType && item.bpjs_kdSadar != null) {
              this.haveBpjsType = true;
            }
            this.dataRiwayat.push(item);
          })
          this.rows = responsePage.data.data.rekam_medis.total;

          if (firstLoad) {
            this.selectedRMId = this.dataRiwayat[0].id
            this.showRightRekamMedis(this.selectedRMId)
          }
        }else{
          this.dataRiwayat = [];
        }
      } catch (error) {
      }
    },
    datetimeFormat(d) {
      return moment(d).format("DD MMM YYYY HH:mm:ss")
    },
    async showRightRekamMedis(id) {
      const res = await axios.get(`${this.url_api}/rekam_medis/${id}?id=${id}&riwayat=true`);
      const { status, data, rujukan } = res.data;
      if (status) {
        this.dataRM = data;
        this.dataRujukan = rujukan;

        if (data.transklinik && data.transklinik.poli_id.toLowerCase().includes('gigi')) this.isPoliGigi = true;
        else this.isPoliGigi = false;
      }
    },
    dateRangeFilter(rawValue) {
      const periode = this.periodeSelected
      const formatBackendDate = "YYYY-MM-DD";
      const rawValueFormat = "DD-MMM-YYYY";

      switch (periode && periode.toLowerCase()) {
        case "pilih tanggal":
          const {
            dateRange
          } = this;
          if (dateRange) {
            const { start: startDate, end: endDate } = dateRange;
            const formatDate = "DD-MM-YYYY";
            if (rawValue) {
              return `${moment(startDate, formatDate).format(rawValueFormat)} - ${moment(endDate, formatDate).format(rawValueFormat)}`;
            } else {
              return `&from=${moment(startDate, formatDate).format(
                formatBackendDate
              )}&to=${moment(endDate, formatDate).format(formatBackendDate)}`;
            }
          } else {
            return null;
          }

        case "hari ini":
          const today = moment().format(formatBackendDate);
          return rawValue ?
            moment().format(rawValueFormat) :
            Array(2)
              .fill(today)
              .map(
                (val, index) =>
                  `&${(item => (item ? "to" : "from"))(index)}=${val}`
              )
              .join("");

        case "minggu ini":
          const startWeek = moment().weekday(0);
          const endWeek = moment().weekday(6);
          return rawValue ?
            `${startWeek.format(rawValueFormat)}-${endWeek.format(
              rawValueFormat
            )}` :
            `&from=${startWeek.format(formatBackendDate)}&to=${endWeek.format(
              formatBackendDate
            )}`;

        case "bulan ini":
          const startMonth = moment().date(1);
          const endMonth = moment().date(31);
          return rawValue ?
            `${startMonth.format(rawValueFormat)}-${endMonth.format(
              rawValueFormat
            )}` :
            `&from=${startMonth.format(
              formatBackendDate
            )}&to=${endMonth.format(formatBackendDate)}`;

        case "semua":
          return ""
        default:
          break;
      }
    }
  },
  mounted() {
    Promise.all([
      this.cekPaketNolock(),
      this.fetchPasien()
    ]);

    if (this.rekam_medis_id) {
      this.$root.$emit('rerender', this.rekam_medis_id)
    }

    this.fetchKodePenyakit();
    this.showLeftRekamMedis(true);
  },
};
</script>

<style>
.modal-backdrop {
  opacity: 0.5 !important;
}

.modal-dialog,
.modal-content {
  height: 100% !important;
}
</style>
<style lang="scss" scoped>
.custom-blue {
	color: #fff;
	background-color: #1384c8;
	border-color: #1384c8;
}

.custom-blue:hover,
.custom-blue:active {
	color: #fff;
	background-color: #1070ad !important;
	border-color: #1070ad !important;
}

.rrm-content {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 700px;
  margin-top: 20px;
}

.mb-header {
  margin-bottom: -15px;
}

@media (max-width: 300px) {
  .rrm-content {
    margin-top: 20px;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.b-list {
  border: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;

  &:hover {
    cursor: pointer;
  }
}

.header-list .active {
  font-weight: bold;
  background-color: transparent;
  border-bottom: 3px solid #1484C9;
}

.pointer {
  cursor: pointer;
}
</style>
